module.exports = __webpack_public_path__ + "img/1172.459f0e1b.jpg";